import { Box } from "@mui/material";
import ProfileImageUpload from "../ProfileImageUpload";

// The avatar on the settings page.
//
// It sits in the page's own layout, sized by the caller. It used to be taken out
// of the flow and pinned to a fixed 160px beside a name indented to clear it,
// which is what broke the page as soon as the window was narrower than a
// desktop.
const ProfilePicture = ({ size = 96 }: { size?: number }) => (
  <Box
    sx={{
      width: size,
      height: size,
      flex: "0 0 auto",
      borderRadius: "50%",
      overflow: "hidden",
      backgroundColor: "background.paper",
    }}
  >
    <ProfileImageUpload size={size} />
  </Box>
);

export default ProfilePicture;
